/*
 * SK Video — Gumlet MP4/HLS + deferred play.
 * HLS: native Safari, hls.js elsewhere. MP4 fallback on fatal HLS errors.
 */
(function () {
  function play(video) {
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  function tryMp4Fallback(video) {
    video.removeAttribute('src');
    var sources = video.querySelectorAll('source');
    if (!sources.length) return false;
    video.load();
    play(video);
    return true;
  }

  function startNativeHls(video, url) {
    video.src = url;
    video.load();
    play(video);
  }

  function startHlsJs(video, url) {
    var Hls = window.Hls;
    if (!Hls || !Hls.isSupported()) return tryMp4Fallback(video);

    var h = new Hls({ capLevelToPlayerSize: true, enableWorker: true });
    video._skHls = h;
    h.loadSource(url);
    h.attachMedia(video);
    h.on(Hls.Events.MANIFEST_PARSED, function () {
      play(video);
    });
    h.on(Hls.Events.ERROR, function (_event, data) {
      if (!data.fatal) return;
      h.destroy();
      video._skHls = null;
      tryMp4Fallback(video);
    });
  }

  function initHlsVideo(video) {
    if (video.dataset.skVideoReady) return;
    video.dataset.skVideoReady = '1';

    var hlsUrl = video.getAttribute('data-hls');
    if (!hlsUrl) {
      play(video);
      return;
    }

    if (video.canPlayType('application/vnd.apple.mpegurl')) {
      startNativeHls(video, hlsUrl);
      video.addEventListener('error', function () {
        tryMp4Fallback(video);
      }, { once: true });
      return;
    }

    if (window.MediaSource) {
      if (window.Hls) {
        startHlsJs(video, hlsUrl);
      } else {
        var attempts = 0;
        var wait = setInterval(function () {
          attempts += 1;
          if (window.Hls) {
            clearInterval(wait);
            startHlsJs(video, hlsUrl);
          } else if (attempts > 40) {
            clearInterval(wait);
            tryMp4Fallback(video);
          }
        }, 50);
      }
      return;
    }

    tryMp4Fallback(video);
  }

  function onDeferredLoaded(dm) {
    var video = dm.querySelector('[data-sk-video]');
    if (!video) return;
    initHlsVideo(video);
  }

  function bindDeferredMedia(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-sk-video-section] deferred-media').forEach(function (dm) {
      if (dm.dataset.skVideoBound) return;
      dm.dataset.skVideoBound = '1';

      if (dm.hasAttribute('loaded')) {
        onDeferredLoaded(dm);
        return;
      }

      var obs = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName === 'loaded' && dm.hasAttribute('loaded')) {
            obs.disconnect();
            onDeferredLoaded(dm);
          }
        });
      });
      obs.observe(dm, { attributes: true });
    });
  }

  function initInline(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-sk-video-section] [data-sk-video-inline]').forEach(function (video) {
      initHlsVideo(video);
    });
  }

  function init(root) {
    bindDeferredMedia(root);
    initInline(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
